import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

export interface DesignSaveAsDialogData {
  currentName: string;
  suggestedName: string;
}

@Component({
  selector: 'app-design-save-as-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './design-save-as-dialog.component.html',
  styleUrl: './design-save-as-dialog.component.scss',
})
export class DesignSaveAsDialogComponent {
  name: string;
  error = '';

  constructor(
    private readonly dialogRef: MatDialogRef<DesignSaveAsDialogComponent, string | null>,
    @Inject(MAT_DIALOG_DATA) readonly data: DesignSaveAsDialogData,
  ) {
    this.name = data.suggestedName;
  }

  save(): void {
    const name = this.name.trim();
    if (!name) {
      this.error = 'Enter a dashboard name.';
      return;
    }
    if (name === this.data.currentName) {
      this.error = 'Choose a different name for the new dashboard.';
      return;
    }
    this.dialogRef.close(name);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  selectText(event: FocusEvent): void {
    (event.target as HTMLInputElement).select();
  }
}
